import React, { useEffect, useState } from "react"
import { Alert, Button, Card, Form } from "react-bootstrap"

import { Required } from "../../../../shared_components/widgets/utils"
import { UserDropdown } from "./utils"

export default function AddEntityForm({
  getTextStr,
  onSubmit,
  entityForm,
  error,
  extraRows = [],
  setValue,
  disabled,
}) {
  const [formComplete, setFormComplete] = useState(false)
  useEffect(() => {
    let isComplete = true
    Object.values(entityForm).forEach((val) => {
      if (!val && isComplete) isComplete = false
    })
    setFormComplete(isComplete)
  }, [entityForm])

  return (
    <Card className={"mb-3"}>
      <Card.Body style={{ backgroundColor: "var(--lanzalake-grey-light-2)" }}>
        <form onSubmit={onSubmit}>
          {error && <Alert variant={"danger"}>{error}</Alert>}
          <div className={"row"}>
            {[
              { id: "general.name", msg: "Name", key: "name", type: "input" },
              { id: "general.description", msg: "Description", key: "description", type: "textarea" },
              ...extraRows,
            ].map((f, idx) => {
              const { id, msg, key, type, defaultOpt, options } = f
              return (
                <div className={"col-md-6 mb-3"} key={`${msg}${idx}`}>
                  <label>{getTextStr(id, msg)}:</label>
                  <Required />
                  {["textarea", "input"].includes(type) && (
                    <Form.Control
                      as={type}
                      rows={2}
                      value={entityForm[key] || ""}
                      onChange={(e) => setValue(key, e.target.value)}
                      required
                    />
                  )}
                  {type === "userDropdown" && (
                    <UserDropdown
                      field={key}
                      current={defaultOpt}
                      setValue={(field, value) => setValue(field, value)}
                      options={options}
                    />
                  )}
                </div>
              )
            })}
          </div>
          <div>
            <Button
              type={"submit"}
              style={{ float: "right" }}
              variant={"primary"}
              disabled={disabled || !formComplete}
            >
              {getTextStr("general.create", "Create")}
            </Button>
          </div>
        </form>
      </Card.Body>
    </Card>
  )
}
